import { ChainType } from '@ankr.com/chains-list';
import { createContext } from 'react';

import { fallbackChain } from 'modules/chains/constants';
import { getFallbackEndpointGroup } from 'modules/endpoints/constants/groups';

import { ChainSelectorsContextValue } from './types';

export const defaultChainsSelectorsValue: ChainSelectorsContextValue = {
  chain: fallbackChain,
  chainCallProtocol: 'rpc/rest',
  chainSubType: undefined,
  chainType: ChainType.Mainnet,
  consensus: undefined,
  consensusGroup: undefined,
  group: getFallbackEndpointGroup('fallback'),
  groupedEndpoints: {
    beaconsMainnet: [],
    beaconsTestnet: [],
    devnet: [],
    mainnet: [],
    opnodesMainnet: [],
    opnodesTestnet: [],
    signet: [],
    testnet: [],
  },
  groups: [],
  hasConsensusSwitch: true,
  isConsensusEnabled: false,
  setChainCallProtocol: () => {},
  setChainSubType: () => {},
  setChainType: () => {},
  setGroupID: () => {},
  setIsConsensusEnabled: () => {},
};

export const ChainSelectorsContext = createContext(defaultChainsSelectorsValue);
